import { FormField, Heading, TextInput } from '@msaf/core-react'
import { WellGeothermalFieldsEdit } from '../../../../types/form-types'
import { SetValue, ValidationErrors } from '../../../hooks/use-edit-form'

interface WellDocumentReferenceInterface {
  fields: Partial<WellGeothermalFieldsEdit>
  isLoading: boolean
  setValue: SetValue<WellGeothermalFieldsEdit>
  validationErrors: ValidationErrors
}

export default function WellDocumentReferenceEdit({
  fields,
  isLoading,
  validationErrors,
  setValue,
}: WellDocumentReferenceInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Document References
      </Heading>
      <FormField
        isSkeleton={isLoading}
        label='Well specifications'
        htmlFor='wellSpecifications'
        validationMessages={validationErrors?.wellSpecifications}
      >
        <TextInput
          isSkeleton={isLoading}
          type='text'
          id='wellSpecifications'
          value={`${fields.wellSpecifications ?? ''}`}
          setValue={(value) => setValue('wellSpecifications', value)}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Deviated well path'
        htmlFor='deviatedWellPath'
        validationMessages={validationErrors?.deviatedWellPath}
      >
        <TextInput
          isSkeleton={isLoading}
          type='text'
          id='deviatedWellPath'
          value={`${fields.deviatedWellPath ?? ''}`}
          setValue={(value) => setValue('deviatedWellPath', value)}
        />
      </FormField>
      <FormField
        isSkeleton={isLoading}
        label='Branched well details'
        htmlFor='branchedWellDetails'
        validationMessages={validationErrors?.branchedWellDetails}
      >
        <TextInput
          isSkeleton={isLoading}
          type='text'
          id='branchedWellDetails'
          value={`${fields.branchedWellDetails ?? ''}`}
          setValue={(value) => setValue('branchedWellDetails', value)}
        />
      </FormField>
    </>
  )
}
